__turbopack_context__.v({
  "active": "-C_gIa_active",
  "bookCall": "-C_gIa_bookCall",
  "content": "-C_gIa_content",
  "rightPadded": "-C_gIa_rightPadded",
  "root": "-C_gIa_root",
  "subContent": "-C_gIa_subContent",
  "typeformContainer": "-C_gIa_typeformContainer",
});
